import { useContext } from 'react'

import { DocFlowSendingContext } from '../../DocFlowSending'

export function useDocFlowSendingContext() {
  return useContext(DocFlowSendingContext)
}
